'use client';

import type { Route } from 'next';
import { useRouter } from 'next/navigation';
import { useForm } from 'react-hook-form';
import { FormCheckbox, FormText } from '../../../../components/form';
import FaIcon, { faSearch } from '../../../../components/icon/FaIcon/FaIcon';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import TradeButton from '../TradeButton/TradeButton';
import styles from './LotteryCollectionSearch.module.scss';

export interface LotteryCollectionSearchProps {
  query?: string;
  hasCheckBox?: boolean;
  isStatus?: boolean;
  isOption?: boolean;
  showTradeButton?: boolean;
  showOptionCheckbox?: boolean;
  tab?: 'lottery' | 'history' | 'goods';
}

function LotteryCollectionSearch({
  query,
  hasCheckBox = true,
  isStatus = false,
  isOption = false,
  showTradeButton = true,
  showOptionCheckbox = true,
  tab,
}: LotteryCollectionSearchProps) {
  const router = useRouter();

  const { handleSubmit, getValues, control } = useForm({
    mode: 'onChange',
    defaultValues: {
      status: isStatus ? ['status'] : [],
      searchText: query || '',
      option: isOption ? ['option'] : [],
    },
  });

  const onChangeCheck = () => {
    const params = new URLSearchParams(location.search);
    if (getValues('status').length > 0) {
      params.set('status', String(true));
    } else {
      params.delete('status');
    }
    if (getValues('option').length > 0) {
      params.set('option', String(true));
    } else {
      params.delete('option');
    }
    // チェックボックスの状態が変わったらページを1に戻す
    params.delete('page');
    router.replace(`${location.pathname}?${params.toString()}` as Route);
  };

  const textSearch = () => {
    const params = new URLSearchParams(location.search);
    if (getValues('searchText').length > 0) {
      params.set('q', getValues('searchText'));
    } else {
      params.delete('q');
    }
    router.replace(`${location.pathname}?${params.toString()}` as Route);
  };

  const onChangeText = () => {
    textSearch();
  };

  const submitText = async () => {
    textSearch();
  };

  const showOptionCheckboxFlag = () => {
    if (!tab) return false;
    if (!showOptionCheckbox) return false;
    return true;
  };

  const showTradeButtonFlag = () => {
    if (!showTradeButton) return false;
    if (process.env.ENV === 'production') return false;
    return true;
  };

  return (
    <>
      <div className={utilsStyles.mtSmall}>
        <form onSubmit={handleSubmit(submitText)}>
          <FormText
            name='searchText'
            control={control}
            outlined
            placeholder='イベント名を検索できます'
            prefix={
              <div className={styles.searchIcon}>
                <FaIcon icon={faSearch} size='xl' />
              </div>
            }
            onChange={onChangeText}
          />
        </form>
      </div>

      <div className={utilsStyles.mtSmall}>
        {query && (
          <div className={utilsStyles.mtXSmall}>
            <p className={`${utilsStyles.textSmall} ${utilsStyles.textBold}`}>"{query}"の検索結果</p>
          </div>
        )}
      </div>
      <div className={`${utilsStyles.mtSmall} ${utilsStyles.flexRowNowrap} ${utilsStyles.spaceBetween}`}>
        <div>
          {hasCheckBox && (
            <FormCheckbox
              name='status'
              items={[
                {
                  value: 'status',
                  child: <>準備中の景品のみを表示する</>,
                },
              ]}
              control={control}
              onChange={onChangeCheck}
            />
          )}

          {/* RAFFLEのみオプションチェックボックスを表示する */}
          {showOptionCheckboxFlag() && (
            <div className={`${styles.optionCheckbox} ${styles[`optionCheckbox--${tab}`]}`}>
              <FormCheckbox
                name='option'
                items={[
                  {
                    value: 'option',
                    child: 'オプション未入力のみを表示する',
                  },
                ]}
                control={control}
                onChange={onChangeCheck}
              />
            </div>
          )}
        </div>
        {showTradeButtonFlag() && (
          <div className={`${styles.tradeButton} ${utilsStyles.flexColumn} ${utilsStyles.alignCenter}`}>
            <TradeButton version='2.0' size='medium' isEnabledTrade={true} currentPage='collection' />
          </div>
        )}
      </div>
    </>
  );
}

export default LotteryCollectionSearch;
